import React, { useState } from "react"
import Breadcrumb from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import "react-phone-input-2/lib/style.css"
import { useSelector } from "react-redux"
import { URLS } from "../../Url"
import axios from "axios"
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  CardText,
  FormGroup,
} from "reactstrap"

const ChangePassword = () => {
  const [form, setForm] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  })

  const [passwordType, setPasswordType] = useState("password")
  const [passwordType1, setPasswordType1] = useState("password")
  const [passwordType12, setPasswordType12] = useState("password")

  const { error, success } = useSelector(state => ({
    error: state.Profile.error,
    success: state.Profile.success,
  }))

  const authUser = JSON.parse(localStorage.getItem("authUser"))
  const token = authUser?.token

  const handleChange = e => {
    const { name, value } = e.target
    setForm(prev => ({
      ...prev,
      [name]: value,
    }))
  }

  const validateForm = () => {
    if (!form.old_password || !form.new_password || !form.confirm_password) {
      toast.error("All fields are required")
      return false
    }
    if (form.new_password !== form.confirm_password) {
      toast.error("New password and confirm password don't match")
      return false
    }
    if (form.new_password.length < 6) {
      toast.error("Password should be at least 6 characters long")
      return false
    }
    return true
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (!validateForm()) return

    try {
      const data = {
        password: form.old_password,
        newpassword: form.new_password,
        confirmpassword: form.confirm_password,
      }

      const response = await axios.post(URLS.ChangePass, data, {
        headers: { Authorization: `Bearer ${token}` },
      })

      if (response.status === 200) {
        toast.success(response.data.message)
        setForm({
          old_password: "",
          new_password: "",
          confirm_password: "",
        })
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message || "Failed to change password")
      } else {
        toast.error("Network error. Please try again.")
      }
    }
  }

  const togglePassword = () => {
    setPasswordType(prev => (prev === "password" ? "text" : "password"))
  }

  const togglePassword1 = () => {
    setPasswordType1(prev => (prev === "password" ? "text" : "password"))
  }

  const togglePassword12 = () => {
    setPasswordType12(prev => (prev === "password" ? "text" : "password"))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title="Bizzmate Supplier"
            breadcrumbItem="Change Password"
          />
          <Row className="d-flex justify-content-center">
            <Col lg="6">
              {error && <Alert color="danger">{error}</Alert>}
              {success && <Alert color="primary">{success}</Alert>}
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit}>
                    <Row className="mt-3">
                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label>
                            Current Password
                            <span className="text-danger">*</span>
                          </Label>
                          <div className="input-group">
                            <input
                              name="old_password"
                              placeholder="Current Password"
                              className="form-control"
                              required
                              type={passwordType}
                              value={form.old_password}
                              onChange={handleChange}
                            />
                            <div className="input-group-btn">
                              <button
                                type="button"
                                className="btn btn-outline-primary"
                                onClick={togglePassword}
                              >
                                {passwordType === "password" ? (
                                  <i
                                    className="fa fa-eye-slash"
                                    aria-hidden="true"
                                  />
                                ) : (
                                  <i className="fa fa-eye" aria-hidden="true" />
                                )}
                              </button>
                            </div>
                          </div>
                        </FormGroup>
                      </Col>
                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label>
                            New Password
                            <span className="text-danger">*</span>
                          </Label>
                          <div className="input-group">
                            <input
                              name="new_password"
                              placeholder="New Password"
                              required
                              type={passwordType1}
                              className="form-control"
                              value={form.new_password}
                              onChange={handleChange}
                            />
                            <div className="input-group-btn">
                              <button
                                type="button"
                                className="btn btn-outline-primary"
                                onClick={togglePassword1}
                              >
                                {passwordType1 === "password" ? (
                                  <i
                                    className="fa fa-eye-slash"
                                    aria-hidden="true"
                                  />
                                ) : (
                                  <i className="fa fa-eye" aria-hidden="true" />
                                )}
                              </button>
                            </div>
                          </div>
                        </FormGroup>
                      </Col>
                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label>
                            Confirm Password
                            <span className="text-danger">*</span>
                          </Label>
                          <div className="input-group">
                            <input
                              name="confirm_password"
                              placeholder="Confirm Password"
                              required
                              type={passwordType12}
                              className="form-control"
                              value={form.confirm_password}
                              onChange={handleChange}
                            />
                            <div className="input-group-btn">
                              <button
                                type="button"
                                className="btn btn-outline-primary"
                                onClick={togglePassword12}
                              >
                                {passwordType12 === "password" ? (
                                  <i
                                    className="fa fa-eye-slash"
                                    aria-hidden="true"
                                  />
                                ) : (
                                  <i className="fa fa-eye" aria-hidden="true" />
                                )}
                              </button>
                            </div>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                    <div style={{ float: "right" }}>
                      <Button color="primary" className="btn-sm" type="submit">
                        Submit
                      </Button>
                    </div>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer position="top-right" autoClose={5000} />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ChangePassword
